import { render, staticRenderFns } from "./PostRow.vue?vue&type=template&id=159662a8&"
import script from "./PostRow.vue?vue&type=script&lang=js&"
export * from "./PostRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports